export default `
<section>
  <p>Täytä hakemus vain sellaisen yrityksen puolesta jota sinulla on oikeus edustaa.
  </p>
  <p>InnoCAPE konsortiumi ei ole vastuussa hakemuksessa annettujen tietojen oikeellisuudesta.
  </p>
  <p>EU:n sisäiset hakemukset käsittelee määrätty alueellinen partneri, muut koordinaattori. InnoCAPE konsortiumi
    päättää mitkä toimittajat sisällytetään kompetenssikartta tietokantaan. Konsortium varaa itselleen oikeuden hylätä
    hakemus tai poistaa jo hyväksytty toimittaja listauksesta joko väliaikaisesti tai pysyvästi palautteen tai
    tarkistuksen perusteella. Hakemuksen jälkeiset muutokset tekee alueellinen partneri joko toimittajan pyynnöstä tai
    itsenäisesti korjatakseen tietoja luotetun lähteen perusteella tai tehdäkseen sisällöstä paremmin palveluun sopivaa.
  </p>
  <p>InnoCAPE konsortiumi ei ota maksua toimittajilta hakemusprosessista tai kompetenssikartalla (listauksessa)
    olemisesta, mutta ei myöskään takaa kuinka paljon näkyvyyttä järjestelmä toimittajalle antaa. Tätä määrittävä
    käyttäjien käyttämät hakutermit sekä hakualgorithmi. Järjestelmä lähettää toimittajalla kuukausittaisen raportin
    saavutetusta näkyvyydestä.
  </p>
  <p>InnoCAPE konsortiumi pitää oikeuden käyttää järjestelmän, toimittajien ja käytön aikana syntyvää dataa
    digitalisaation tilan ja tarpeiden reportointiin sekä analysointiin.
  </p>
  <p>Jos sinulla on kysyttävää kompetenssikartasta, hakemus prosessista tai muusta liittyvästä, ota yhteyttä lähimpään
    <a target="_blank" href="https://dma.innocape.eu/en/contacts" rel="noopener noreferrer">projektin partneriin
    </a>.
  </p>
</section>
`
